import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import useApiPost from '../hooks/postData';
import toast from 'react-hot-toast';
import axios from 'axios';
import { useGetAllSettingsQuery } from '../../store/api/GetAllGeneralSettings';
import { useSelector } from 'react-redux';

function AppControl() {
  const token = Cookies.get("Snapta_Admin_Token");
  const { data: SettingData, refetch } = useGetAllSettingsQuery({ token: token });
  const isSidebarOpen = useSelector((state) => state.sidebar.isOpen);

  const [gameMaxItems, setGameMaxItems] = useState(6);
  const [appVersion, setAppVersion] = useState("");
  const [playStoreUrl, setPlayStoreUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [isEdited, setIsEdited] = useState(false);

  useEffect(() => {
    if (SettingData && SettingData.setting_list) {
      const settings = SettingData.setting_list;
      setGameMaxItems(settings.game_max_selectable_items || 6);
      setAppVersion(settings.app_version || "");
      setPlayStoreUrl(settings.play_store_url || "");
    }
  }, [SettingData]);

  const handleGameItemsChange = (e) => {
    const val = e.target.value;
    if (val === "" || (/^\d+$/.test(val) && Number(val) <= 8)) {
      setGameMaxItems(val);
      setIsEdited(true);
    }
  };

  const handleSave = async () => {
    const gameItems = parseInt(gameMaxItems);
    if (isNaN(gameItems) || gameItems < 1 || gameItems > 8) {
      toast.error("Game selectable items must be a whole number between 1 and 8");
      return;
    }

    setLoading(true);
    try {
      const formDataToUpload = new FormData();
      formDataToUpload.append("game_max_selectable_items", gameItems);
      formDataToUpload.append("app_version", appVersion);
      formDataToUpload.append("play_store_url", playStoreUrl);

      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiUrl}/update_settings`, formDataToUpload, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success(response?.data?.message || "App control settings updated!");
      refetch();
      setIsEdited(false);
    } catch (err) {
      toast.error("Something went wrong");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`dark:bg-primary ${isSidebarOpen ? "xl:pl-20" : "xl:pl-72"}`}>
      <div className="px-4 pb-10 pt-6 xl:px-6">
        <h2 className="text-[#000000] font-semibold font-poppins text-xl pb-5 dark:text-darkText">
          App Control
        </h2>

        <div className="border border-opacity-gradient dark:border-[#1F1F1F] bg-[#FFFFFF] dark:bg-primary rounded-lg p-6">
          <div className="grid gap-6 md:grid-cols-3">

            {/* Game Max Selectable Items */}
            <div>
              <label className="text-[#000000] font-poppins font-semibold text-sm dark:text-darkText">
                Game Max Selectable Items <span className="text-xs font-normal text-[#777777]">(1 - 8)</span>
              </label>
              <input
                type="number"
                min="1"
                max="8"
                step="1"
                placeholder="e.g. 6"
                className="border dark:bg-transparent dark:text-darkText dark:border-borderColor border-opacity-gradient rounded-lg w-full py-3 my-1 px-4 bg-white focus:outline-none focus:ring-1 focus:ring-header"
                value={gameMaxItems}
                onChange={handleGameItemsChange}
              />
            </div>

            {/* App Version */}
            <div>
              <label className="text-[#000000] font-poppins font-semibold text-sm dark:text-darkText">
                App Version
              </label>
              <input
                type="text"
                placeholder="e.g. 1.0"
                className="border dark:bg-transparent dark:text-darkText dark:border-borderColor border-opacity-gradient rounded-lg w-full py-3 my-1 px-4 bg-white focus:outline-none focus:ring-1 focus:ring-header"
                value={appVersion}
                onChange={(e) => { setAppVersion(e.target.value); setIsEdited(true); }}
              />
            </div>

            {/* Play Store URL */}
            <div>
              <label className="text-[#000000] font-poppins font-semibold text-sm dark:text-darkText">
                Play Store URL
              </label>
              <input
                type="text"
                placeholder="https://play.google.com/..."
                className="border dark:bg-transparent dark:text-darkText dark:border-borderColor border-opacity-gradient rounded-lg w-full py-3 my-1 px-4 bg-white focus:outline-none focus:ring-1 focus:ring-header"
                value={playStoreUrl}
                onChange={(e) => { setPlayStoreUrl(e.target.value); setIsEdited(true); }}
              />
            </div>

          </div>
        </div>

        {/* Save Button */}
        <div className="flex justify-center py-8">
          <button
            style={{ backgroundColor: isEdited ? '#593A99' : '#B8A6D9' }}
            className="px-24 py-3 font-medium text-white rounded-xl transition-all"
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AppControl;